
import config from '../config.json'

export default {
  // 获取省市区
  getProvince: config.api_url + 'commonModule-nationalAction@getAllProvince',
  getPlaceByParent: config.api_url + 'commonModule-nationalAction@getByParentId',
  // 公共
  getDicts: config.api_url + 'commonModule-dictActionFactory@getDictsByKey',
  getAiCustomAreaDicts: config.api_url + 'platformModule-aiCustomAreaActionFactory@getCurrentUserAiCustomAreasDicts',
  // 菜单按钮
  getMenu: config.api_url + 'platformModule-platformUserRole@getPlatformMenuTree',
  getBtnAuth: config.api_url + 'platformModule-platformUserRole@checkButtonAuth',
  getBtnAuthByMenu: config.api_url + 'platformModule-platformUserRole@checkButtonAuthByMenuId',
  // 上传
  upload: {
    url: config.api_url_load + 'file/upload',
    ueditor: config.api_url_load + 'ueditor/upload'
  },
  // 获取验证码
  getCode: {
    send: config.api_url + 'commonModule-identifyingCode@sendCode',
    randomImage: config.api_url + 'commonModule-identifyingCode@randomImage'
  },
  // 个人中心
  user: {
    getById: config.api_url + 'platformModule-sysAdminuser@findAdminuserById',
    changePws: config.api_url + 'platformModule-sysAdminuser@modifyPassword',
    changeUser: config.api_url + 'platformModule-sysAdminuser@updateAdminuser',
    changeUserBaseInfo: config.api_url + 'platformModule-sysAdminuser@updateAdminuserBaseInfo',
    changePhone: config.api_url + 'platformModule-sysAdminuser@changePhone'
  },
  // 工作台
  portal: {
    getPlatformPending: config.api_url + 'platformModule-workbenchPlatform@getPlatformPending',
    // 图表
    getPlatformStatisticsData: config.api_url + 'platformModule-workbenchPlatform@getPlatformStatisticsData'
  },
  // 运营平台登录
  platformlogin: {
    // 常量-----本地session、token的名字
    sessionId: 'platformsessionId',
    userInfo: 'platfromuser',
    userChName: 'platfromuserName',
    // 平台登录
    user: config.api_url + 'platformModule-sysAdminuser@loginUser',
    // 身份验证
    verfify: config.api_url + 'platformModule-sysAdminuser@authentication',
    // 重置密码
    resetPassword: config.api_url + 'platformModule-sysAdminuser@resetPassword',
    // 退出登录
    logout: config.api_url + 'platformModule-sysAdminuser@logout'
  },
  // 我是货主
  shipper: {
    // 货源管理
    source: {
      queryAll: config.api_url + 'logisticsModule-goods@queryGoods',
      queryById: config.api_url + 'logisticsModule-goods@getById',
      add: config.api_url + 'logisticsModule-goods@createGoods',
      delete: config.api_url + 'logisticsModule-goods@deleteGoods',
      update: config.api_url + 'logisticsModule-goods@updateGoods',
      remove: config.api_url + 'logisticsModule-goods@removeGoods',
      getDraftCount: config.api_url + 'logisticsModule-goods@getDraftCount'
    }
  },
  // 我是承运商
  carrier: {

  },
  // 宝武提卸管理
  ladingBill: {
    // 提货
    queryAll: config.api_url + 'platformModule-entrustCoordinationActionFactory@queryLadingBill',
    // 承运商提交导出门禁
    export: config.api_url_load + 'export/exportLadingBill',
    // 承运商提交导出提单
    export2: config.api_url_load + 'export/exportLadingBill2',
    // 卸货
    getOutturnReports: config.api_url + 'platformModule-outturnReport@getOutturnReports',
    exportReports: config.api_url_load + 'export/exportOutturnReport',
    // 企业
    getCorporates: config.api_url + 'platformModule-corporate@getCorporates',
    chooseCorporate: config.api_url + 'platformModule-corporate@chooseCorporate',
    getOutturnCorporates: config.api_url + 'platformModule-corporate@getOutturnCorporates',
    deleteCorporate: config.api_url + 'platformModule-corporate@deleteCorporate',
    // 货主提货
    queryTradingPlatformTask: config.api_url + 'platformModule-entrustCoordinationActionFactory@queryTradingPlatformTask',
    // 货主提交导出门禁
    exportTradingPlatformTask: config.api_url_load + 'export/exportTradingPlatformTask',
    // 货主提交导出提单
    exportTradingPlatformTask2: config.api_url_load + 'export/exportTradingPlatformTask2',
    // 持证车辆
    getCar: config.api_url + 'platformModule-holdCertificateCar@getCar',
    addCar: config.api_url + 'platformModule-holdCertificateCar@addCar',
    deleteCar: config.api_url + 'platformModule-holdCertificateCar@deleteCar',
    getHoldCarGoods: config.api_url + 'platformModule-holdCertificateCar@getHoldCarGoods',
    getHoldCarOutturnReports: config.api_url + 'platformModule-outturnReport@getHoldCarOutturnReports',
    // 导出卸货申报
    exportHoldCarOutturnReport: config.api_url_load + 'export/exportHoldCarOutturnReport',
    // 导出持证车辆导出门禁
    exportHoldCarGood: config.api_url_load + 'export/exportHoldCarGood',
    // 导出持证车辆导出提单
    exportHoldCarGood2: config.api_url_load + 'export/exportHoldCarGood2',
    updateHasCopy: config.api_url + 'platformModule-holdCertificateCar@updateHasCopy',
    // 导出附件zip
    exportToZip: config.api_url_load+'exportToZip/exportAttachment'
  },

  // 资金管理
  funds: {

  },
  // 系统管理
  system: {
    employee: {
      queryAll: config.api_url + 'platformModule-sysAdminuser@queryPageAdminuser',
      add: config.api_url + 'platformModule-sysAdminuser@createAdminuser',
      update: config.api_url + 'platformModule-sysAdminuser@updateAdminuser',
      findById: config.api_url + 'platformModule-sysAdminuser@findAdminuserById',
      removeAdminuser: config.api_url + 'platformModule-sysAdminuser@removeAdminuser',
      // 查询所有厂区
      getAiCustomAreas: config.api_url + 'platformModule-aiCustomAreaActionFactory@getAiCustomAreas'
    },
    role: {
      // 角色查询
      queryPage: config.api_url + 'platformModule-sysRole@queryPageRole',
      // 添加角色
      add: config.api_url + 'platformModule-sysRole@createRole',
      // 更新角色
      update: config.api_url + 'platformModule-sysRole@updateRole',
      // 删除角色
      delete: config.api_url + 'platformModule-sysRole@deleteRole',
      // 根据id获取角色信息
      getById: config.api_url + 'platformModule-sysRole@getRole',
      // 根据id获取角色和关联的菜单按钮权限
      queryRoleInfoById: config.api_url + 'platformModule-sysRole@queryRoleInfoById'
    },
    menu: {
      updateMenu: config.api_url + 'platformModule-sysMenuButton@updateMenu',
      deleteMenu: config.api_url + 'platformModule-sysMenuButton@deleteMenu',
      addMenu: config.api_url + 'platformModule-sysMenuButton@createMenu',
      menuTreeQuery: config.api_url + 'platformModule-sysMenuButton@queryMenuTree',
      // button
      getButtonByMenuId: config.api_url + 'platformModule-sysMenuButton@findButtonByMenuId',
      getButtonById: config.api_url + 'platformModule-sysMenuButton@findButtonById',
      deleteButton: config.api_url + 'platformModule-sysMenuButton@deleteButtonById',
      addButton: config.api_url + 'platformModule-sysMenuButton@createButton',
      updateButton: config.api_url + 'platformModule-sysMenuButton@updateButton'
    },

    jobmanager: {
      queryJob: config.api_url + 'job@queryJob',
      updateJob: config.api_url + 'job@updateJob',
      createJob: config.api_url + 'job@insertJob',
      deleteJob: config.api_url + 'job@deleteJob',
      pauseJob: config.api_url + 'job@pauseJob',
      restartJob: config.api_url + 'job@restartJob',
      runJob: config.api_url + 'job@runJob',
      resumeJob: config.api_url + 'job@resumeJob'
    },
    configManager: {
      queryConfigInfoByPage: config.api_url + 'commonModule-configInfo@queryConfigInfoByPage',
      getConfigInfoById: config.api_url + 'commonModule-configInfo@getConfigInfoById',
      updateConfigInfo: config.api_url + 'commonModule-configInfo@updateConfigInfo',
      createConfigInfo: config.api_url + 'commonModule-configInfo@createConfigInfo'
    },
    cacheManager: {
      refreshDictCache: config.api_url + 'commonModule-dictActionFactory@refreshDictCache',
      refreshConfigCache: config.api_url + 'commonModule-configInfo@refreshConfigCache'
    },
    // 消息中心
    news: {
      queryAll: config.api_url + 'logisticsModule-msgActionFactory@findAllMsgInfos',
      queryById: config.api_url + 'logisticsModule-msgActionFactory@findMsgInfoById',
      updateById: config.api_url + 'logisticsModule-msgActionFactory@updateMsgInfoById',
      Refer: config.api_url + 'logisticsModule-msgActionFactory@updateMsgInfoByReferId',
      // 判断当前用户是否有消息
      msgInfoIsUnRead: config.api_url + 'logisticsModule-msgActionFactory@msgInfoIsUnRead'
    },
    // 消息模板
    template: {
      add: config.api_url + 'platformModule-platformMsgActionFactory@createMsgTemplate',
      update: config.api_url + 'platformModule-platformMsgActionFactory@updateMsgTemplate',
      queryAll: config.api_url + 'platformModule-platformMsgActionFactory@findAllMsgTemplates',
      delete: config.api_url + 'platformModule-platformMsgActionFactory@deleteMsgTemplate',
      queryById: config.api_url + 'platformModule-platformMsgActionFactory@getMsgTemplate',
      getConfigInfoByKey: config.api_url + 'commonModule-configInfo@getConfigInfoByKey'
    },
    rules: {
      queryAll: config.api_url + 'platformModule-platformMsgActionFactory@findAllMsgRules',
      queryById: config.api_url + 'platformModule-platformMsgActionFactory@getMsgRule',
      add: config.api_url + 'platformModule-platformMsgActionFactory@createMsgRule',
      edit: config.api_url + 'platformModule-platformMsgActionFactory@updateMsgRule',
      updateStatus: config.api_url + 'platformModule-platformMsgActionFactory@updateMsgRuleStatus',
      delete: config.api_url + 'platformModule-platformMsgActionFactory@deleteMsgRule',
      findAllUserInfoSelected: config.api_url + 'platformModule-platformMsgActionFactory@findAllUserInfoSelected',
      findUnselected: config.api_url + 'platformModule-platformMsgActionFactory@findAllUserInfoUnselected',
      deleteSubscriber: config.api_url + 'platformModule-platformMsgActionFactory@deleteMsgSubscriber',
      createMsgSubscriber: config.api_url + 'platformModule-platformMsgActionFactory@createMsgSubscriber'
    },
    // 发送消息
    sendMsg: {
      add: config.api_url + 'platformModule-platformMsgActionFactory@createMsgInfoSends',
      queryAll: config.api_url + 'platformModule-platformMsgActionFactory@findAllMsgInfoByType'

    }
  },
  // 下载中心
  download: {
    getDownloadCenters: config.api_url + 'platformModule-downloadCenter@getDownloadCenters',
    add: config.api_url + 'platformModule-downloadCenter@insertDownloadCenter',
    edit: config.api_url + 'platformModule-downloadCenter@updateDownloadCenter',
    delete: config.api_url + 'platformModule-downloadCenter@deleteDownloadCenter',
    // 撤消
    publishDownloadCenter: config.api_url + 'platformModule-downloadCenter@publishDownloadCenter'
  },
  // 黑名单管理
  blackList: {
    company: {
      queryAll: config.api_url + 'platformModule-blackListActionFactory@findAllBlackWhiteListsForPlatform',
      update: config.api_url + 'platformModule-blackListActionFactory@updateBlackWhiteListModelForStatePlatform',
      add: config.api_url + 'platformModule-blackListActionFactory@createBlackListModels',
      queryAllCorporateInfos: config.api_url + 'platformModule-blackListActionFactory@findAllCorporateInfosForPlatform',
      queryAllDriverInfos: config.api_url + 'platformModule-blackListActionFactory@findAllDriverInfosForPlatform',
      queryAllCarInfos: config.api_url + 'platformModule-blackListActionFactory@findAllCarInfosForPlatform'
    }
  },

  // 客商管理
  merchantManage: {
    companyManage: {
      // 获取所有企业信息
      queryAll: config.api_url + 'platformModule-corporate@findAllCorporate',

      getCorDetail: config.api_url + 'platformModule-corporate@getCorporate',
      // 企业资料变更审核状态
      updateAltert: config.api_url + 'platformModule-corporate@updateAlterProcessState',
      // 企业变更审核状态
      updateAudit: config.api_url + 'platformModule-corporate@updateAuditProcessState',
      // 注销企业
      logoutCorporate: config.api_url + 'platformModule-corporate@logoutCorporate',
      // 启用企业
      startCorporate: config.api_url + 'platformModule-corporate@startCorporate',
      // 企业子账号管理
      getCorporateUserInfo: config.api_url + 'platformModule-corporateUserInfo@getCorporateUserInfo',
      getAlterAuditById: config.api_url + 'platformModule-corporate@getAlterAuditById',
      getRegisterAuditDetail: config.api_url + 'platformModule-corporate@getRegisterAuditDetail',
      // 查询企业监控权限
      getBcCorporateInfoExt: config.api_url + 'platformModule-corporate@getBcCorporateInfoExt',
      // 更新企业监控权限
      updateCorporateInfoExt: config.api_url + 'platformModule-corporate@updateOrSaveIotDataQuery',
    },
    // 司机管理
    driver: {
	  findAuditDrivers: config.api_url + 'platformModule-driver@findAuditDrivers',
	  getAuditDriverById:config.api_url + 'platformModule-driver@getAuditDriverById',
	  getDriverCreditInfoById:config.api_url + 'platformModule-driver@getDriverCreditInfoById',
	  auditDriver:config.api_url + 'platformModule-driver@auditDriver',
	  getAuditHistory:config.api_url + 'platformModule-driver@getAuditHistory',
      queryAll: config.api_url + 'platformModule-driver@findAllDrivers',
      getById: config.api_url + 'platformModule-driver@getDriverById',
      black: config.api_url + 'platformModule-driver@addDriverToBlackList',
      addBlackListWithReason: config.api_url + 'platformModule-driver@addBlackListWithReason',
      export: config.api_url_load + 'export/exportDriver',
      checkDriver: config.api_url + 'platformModule-driver@checkDriver',
      passDriver: config.api_url + 'platformModule-driver@passDriver',

	    findAuditSupercargos: config.api_url + 'platformModule-driver@findAuditSupercargos',
      passSupercargos: config.api_url + 'platformModule-driver@passSupercargos',
      auditSupercargos:config.api_url + 'platformModule-driver@auditSupercargos',
      updateNeedLearnFaceRecognition: config.api_url + 'platformModule-driverLearn@updateNeedLearnFaceRecognition',
      delById:config.api_url + 'platformModule-driver@deleteDriver',
      // 驾押人员履历（审核缓存表）
      findAllDriverAuditInfos: config.api_url + 'platformModule-driver@findAllDriverAuditInfos',
    },
    // 车辆管理
    carManage: {
      getById: config.api_url + 'platformModule-carAudit@getCarById',
      queryAll: config.api_url + 'platformModule-carAudit@findAllCar',
      audit: config.api_url + 'platformModule-carAudit@auditCar',
      delete: config.api_url + 'platformModule-carAudit@deleteCar',
      getAuditInfos: config.api_url + 'platformModule-carAudit@getAuditInfos',
      getCarCreditById: config.api_url + 'platformModule-carAudit@getCarCreditById',
      // 获取司机数据
      getDriver: config.api_url + 'platformModule-driver@getDrivers',
      modifyCar: config.api_url + 'platformModule-carAudit@modifyCar',
      checkCarByLicensePlate: config.api_url + 'platformModule-carAudit@checkCarByLicensePlate',
      exportAllcars: config.api_url_load + 'carExport/exportAllcars',
      exportCertification: config.api_url_load + 'carExport/exportCertification',
      passCar: config.api_url+'platformModule-carAudit@passCar',
      // 车辆履历（缓存表）
      findAllCarCacheInfos: config.api_url + 'platformModule-carAudit@findAllCarCacheInfos',
    },
    // 挂车管理
    trailerManage: {
      getById: config.api_url + 'platformModule-carTrailerActionFactory@findCarTrailerById',
      getByLicensePlate: config.api_url + 'platformModule-carTrailerActionFactory@findCarTrailerByLicensePlate',
      queryAll: config.api_url + 'platformModule-carTrailerActionFactory@findAllCarTrailerPlatform',
      getTrailers: config.api_url + 'platformModule-carTrailerActionFactory@findAllCar',
      getTrailerById: config.api_url + 'platformModule-carTrailerActionFactory@getTrailerById',
      modifyCar: config.api_url + 'platformModule-carTrailerActionFactory@modifyCar',
      getAuditInfos: config.api_url + 'platformModule-carTrailerActionFactory@getAuditInfos',
      deleteTrailer: config.api_url + 'platformModule-carTrailerActionFactory@deleteTrailer',
      auditTrailer: config.api_url + 'platformModule-carTrailerActionFactory@auditTrailer',
      exportAllTrailer:config.api_url_load+'trailerExport/exportAllTrailer',
      exportCertification:config.api_url_load+'trailerExport/exportCertification',
      exportAllCacheTrailer:config.api_url_load+'trailerExport/exportAllCacheTrailer',
      getTrailerCreditById: config.api_url+'platformModule-carTrailerActionFactory@getTrailerCreditById',
      passTrailer: config.api_url+'platformModule-carTrailerActionFactory@passTrailer',
      // 挂车履历（缓存表）
      findAllTrailerCacheInfos: config.api_url + 'platformModule-carTrailerActionFactory@findAllTrailerCacheInfos',
    },
    // 罐车管理
    tankManage: {
      queryAll: config.api_url + 'platformModule-carTrailerInspection@findAllCarTrailerInspection',
      passInspection: config.api_url + 'platformModule-carTrailerInspection@passInspection',
      correctInspection: config.api_url + 'platformModule-carTrailerInspection@correctInspection',
      deleteInspection: config.api_url + 'platformModule-carTrailerInspection@deleteInspection',
      // 罐检履历（缓存表）
      findAllCacheInfos: config.api_url + 'platformModule-carTrailerInspection@findAllCarTrailerInspectionCacheInfos',
    },
  },
  // 企业信息
  cor: {
    // 企业认证审核
    findAllCorporateAudit: config.api_url + 'platformModule-corporate@findAllCorporateAudit',
    // 修改企业审核状态
    updateState: config.api_url + 'platformModule-corporate@updateAuditProcessState',
    // 资料变更审核
    findAllAlterAudit: config.api_url + 'platformModule-corporate@findAllAlterAudit',
    updateAlterProcessState: config.api_url + 'platformModule-corporate@updateAlterProcessState',
    // 审核记录
    getAuditRecord: config.api_url + 'platformModule-corporate@getAuditRecord',
    getAuditRecords: config.api_url + 'platformModule-corporate@getAuditRecords'
  },
  // 结算管理
  settlement: {
    queryAll: config.api_url + 'platformModule-platformOrderSettlementActionFactory@findAllOrderSettlements',
    findBySettId: config.api_url + 'platformModule-platformOrderSettlementActionFactory@findOrderSettlementById'
  },
  // 保证金管理
  deposit: {
    // 签约保证金
    signDeposit: {
      queryAll: config.api_url + 'platformModule-platformSignDepositActionFactory@findAllSignDeposits',
      update: config.api_url + 'platformModule-platformSignDepositActionFactory@updateSignDepositForDepositState'
    },
    // 保证金白名单
    depositWhiteList: {
      queryAll: config.api_url + 'platformModule-depositWhiteListActionFactory@findAllDepositWhiteLists',
      update: config.api_url + 'platformModule-depositWhiteListActionFactory@updateBlackWhiteListModelForState'
    },
    // 信誉保证金
    sincerityDeposit: {
      queryAll: config.api_url + 'platformModule-platformSincerityDepositActionFactory@findSincerityDeposits',
      queryAllById: config.api_url + 'platformModule-platformSincerityDepositActionFactory@findAllSincerityDepositsByOwnerId'
    }
  },
  // 车源管理
  carSource: {
    queryAll: config.api_url + 'platformModule-option@findAllOptions',
    queryById: config.api_url + 'platformModule-option@getOptionById',
    batch: config.api_url + 'platformModule-option@batchSoldOutOption'
  },
  // 货源管理
  sourceManage: {
    queryAll: config.api_url + 'platformModule-goodsActionFactory@queryGoods',
    // 货源下架
    out: config.api_url + 'platformModule-goodsActionFactory@removeGoods',
    // 货源详情
    queryById: config.api_url + 'platformModule-goodsActionFactory@getById'
  },
  // 安全学习
  study: {
    // 题库
    add: config.api_url + 'platformModule-subjectLibraryActionFactory@insertSubjectLibrary',
    queryAll: config.api_url + 'platformModule-subjectLibraryActionFactory@findAllBySubjectLibrary',
    queryById: config.api_url + 'platformModule-subjectLibraryActionFactory@getSubjectLibraryById',
    delete: config.api_url + 'platformModule-subjectLibraryActionFactory@deleteSubjectLibrary',
    update: config.api_url + 'platformModule-subjectLibraryActionFactory@updateSubjectLibrary',
    getEchart: config.api_url + 'platformModule-subjectLibraryActionFactory@countExamPassDriver',
    // 试题
    findAll: config.api_url + 'platformModule-examQuestionActionFactory@findAllExamQuestion',
    insert: config.api_url + 'platformModule-examQuestionActionFactory@insertExamQuestion',
    remove: config.api_url + 'platformModule-examQuestionActionFactory@deleteExamQuestion',
    findById: config.api_url + 'platformModule-examQuestionActionFactory@getExamQuestionById',
    modifi: config.api_url + 'platformModule-examQuestionActionFactory@updateExamQuestion',
    // 公司
    getAllCompany: config.api_url + 'platformModule-companyActionFactory@getAllCompany',
    // 考试管理
    insertExam: config.api_url + 'platformModule-examActionFactory@insertExam',
    deleteExam: config.api_url + 'platformModule-examActionFactory@deleteExam',
    findAllExam: config.api_url + 'platformModule-examActionFactory@findAllExam',
    getExamById: config.api_url + 'platformModule-examActionFactory@getExamById',
    updateExam: config.api_url + 'platformModule-examActionFactory@updateExam',
    getExamPassDrivers: config.api_url + 'platformModule-driver@getExamPassDrivers',
    exportExamPassDrivers: config.api_url_load + 'studyExport/exportExamPassDrivers'
  },
  // 运输管理
  transportManage: {
    /* 运单管理 */
    wayBillManage: {
      queryAll: config.api_url + 'platformModule-orderActionFactory@queryOrder',
      // 关闭运单
      closeOrder: config.api_url + 'platformModule-orderActionFactory@closeOrder',
      // 获取详情
      queryById: config.api_url + 'platformModule-orderActionFactory@getOrder',
      // 获取对应运输任务
      getTaskData: config.api_url + 'logisticsModule-transportTask@getTransportTaskByOrderSn'
    },
    // 运输任务管理
    transportTask: {
      queryAll: config.api_url + 'platformModule-transportTaskActionFactory@queryTransportTask',
      // 关闭任务
      closeTask: config.api_url + 'platformModule-transportTaskActionFactory@closeTransportTask',
      // 获取详情
      queryById: config.api_url + 'platformModule-transportTaskActionFactory@getTransportTaskById'
    },
		  // 保单列表
		  insure: {
			  getInsureList: config.api_url + 'platformModule-transportTaskActionFactory@getInsureRecord'
		  }
  },
  // 大单招标管理
  bidsManage: {
    queryAll: config.api_url + 'platformModule-bidsActionFactory@queryBids',
    // 删除大单招标
    deleteBid: config.api_url + 'platformModule-bidsActionFactory@deleteBids',
    // 获取详情
    getDetails: config.api_url + 'platformModule-bidsActionFactory@getById',
    // 获取报价信息
    queryBidders: config.api_url + 'platformModule-bidsActionFactory@queryBiddersByBidsId'
  },

  // 资讯管理
  newsManage: {
    // 获取栏目
    getBusiColumn: config.api_url + 'platformModule-columnActionFactory@getBusiColumn',
    // 创建栏目
    creatColumn: config.api_url + 'platformModule-columnActionFactory@inserColumn',
    // 编辑栏目
    modifyColumn: config.api_url + 'platformModule-columnActionFactory@updateBcBusiColumn',
    // 删除栏目
    deleteColumn: config.api_url + 'platformModule-columnActionFactory@deleteBusiColumn',
    // 根据栏目得资讯
    getNewsByColumnId: config.api_url + 'platformModule-columnActionFactory@getInformations',
    // 根据资讯名字查资讯
    getNewsByNewsName: config.api_url + 'platformModule-informationActionFactory@getBccreateBcBusiInformation',
    // 删除资讯
    deleteNews: config.api_url + 'platformModule-informationActionFactory@deleteInformation',
    // 批量删除资讯
    deleteNewsSelected: config.api_url + 'platformModule-informationActionFactory@deleteAllInformation',
    // 添加资讯
    addNews: config.api_url + 'platformModule-informationActionFactory@increateBcBusiInformation',
    // 资讯置顶
    newsSetTop: config.api_url + 'platformModule-informationActionFactory@updateBcBusiInformation',
    // 编辑资讯
    modifyNews: config.api_url + 'platformModule-informationActionFactory@updateBcBusiInform',
    // 获取资讯详情
    getNewsDetails: config.api_url + 'platformModule-informationActionFactory@getInformation'
  },
  // 公告管理
  announcementManage: {
    // 根据条件查数据
    searchTableItem: config.api_url + 'platformModule-announcementActionFactory@getBccreateBcAnnouncement',
    // 删除数据
    deleteItem: config.api_url + 'platformModule-announcementActionFactory@deleteInformation',
    // 批量删除数据
    deleteItemsSelected: config.api_url + 'platformModule-announcementActionFactory@deleteAllInformation',
    // 撤回删除数据
    revokeItemsSelected: config.api_url + 'platformModule-announcementActionFactory@revokeAllInformation',
    // 发布删除数据
    publishItemsSelected: config.api_url + 'platformModule-announcementActionFactory@publishAllInformation',
    // 添加数据
    addItem: config.api_url + 'platformModule-announcementActionFactory@increateItem',
    // 编辑数据
    modifyItem: config.api_url + 'platformModule-announcementActionFactory@updateItem',
    // 获取公告详情
    getItemDetails: config.api_url + 'platformModule-announcementActionFactory@getInformation',
    // 公告置顶
    itemSetTop: config.api_url + 'platformModule-announcementActionFactory@updateTopItem',
    // banner
    queryAnnouncementList: config.api_url + 'platformModule-announcementActionFactory@queryAnnouncementList',
    createAnnouncementList: config.api_url + 'platformModule-announcementActionFactory@createAnnouncementList'
  },

  // 广告管理
  adManage: {
    queryAll: config.api_url + 'platformModule-adInformationActionFactory@getPageAdInformation',
    adDelect: config.api_url + 'platformModule-adInformationActionFactory@deleteAdInformation',
    // 批量删除
    adSelectDelect: config.api_url + 'platformModule-adInformationActionFactory@getAdInformation',
    // 创建
    adAdd: config.api_url + 'platformModule-adInformationActionFactory@createAdInformation',
    queryById: config.api_url + 'platformModule-adInformationActionFactory@getAdInformationById',
    adModify: config.api_url + 'platformModule-adInformationActionFactory@updateAdInformation'
  },

  // 知名企业
  wellknownCorp: {
    queryByCorpType: config.api_url + 'platformModule-corporateSpecialActionFactory@getCorprateSpecial',
    wellknownCorpDelete: config.api_url + 'platformModule-corporateSpecialActionFactory@deleteCorprateSpeciaById',
    wellknownCorpAdd: config.api_url + 'platformModule-corporateSpecialActionFactory@createCorprateSpecial',
    getUnSelectCorp: config.api_url + 'platformModule-corporateSpecialActionFactory@getCorprateInfo'
  },

  // 意见反馈
  feedback: {
    optionsQuery: config.api_url + 'platformModule-suggestionFeedBackApprovalActionFactory@getSuggestionFeedBack',
    audit: config.api_url + 'platformModule-suggestionFeedBackApprovalActionFactory@suggestionFeedBack'
  },
  // 洗罐站管理
  tank: {
    queryByName: config.api_url + 'platformModule-washingActionFactory@getWashingByName',
    add: config.api_url + 'platformModule-washingActionFactory@createWashing',
    update: config.api_url + 'platformModule-washingActionFactory@updateWashingStation',
    queryById: config.api_url + 'platformModule-washingActionFactory@getWashingById',
    delete: config.api_url + 'platformModule-washingActionFactory@deleteAllBcWashingStation'
  },

  // 公司管理
  corporationManage: {
    queryByName: config.api_url + 'platformModule-companyActionFactory@getCompanyByName',
    corporationDelete: config.api_url + 'platformModule-companyActionFactory@deleteCompany',
    // 批量删除
    corporationSelectDelect: config.api_url + 'platformModule-companyActionFactory@deleteAllCompany',
    corporationAdd: config.api_url + 'platformModule-companyActionFactory@creatCompany',
    queryById: config.api_url + 'platformModule-companyActionFactory@getCompanyById',
    corporationModify: config.api_url + 'platformModule-companyActionFactory@updateCompany'
  },
  // 防疫管理
  epidemicPrevention: {
    // 厂区
    queryAllFactory: config.api_url + 'platformModule-companyActionFactory@findCompanyByUser',
    queryAll: config.api_url + 'platformModule-antiepidemicManageActionFactory@queryDriverAntiepidemic'
  },

  // 防疫上报
  epidemicReport: {
    // 车辆信息查询
    queryAllFactory: config.api_url + 'platformModule-antiepidemicManageBwty@queryCarAndDriverInfo',
    epidemicReport: config.api_url + 'platformModule-antiepidemicManageBwty@antiepidemicUpload',
    queryDriverPicInfo: config.api_url + 'platformModule-antiepidemicManageBwty@queryDriverPicInfo',
    // 责任人查询
    queryRespPerson: config.api_url + 'platformModule-antiepidemicManageBwty@queryRespPerson',
    // 新增车辆
    addCarAndDriverInfo: config.api_url + 'platformModule-antiepidemicManageBwty@addCarAndDriverInfo',

    // 分页查询车辆
    queryCarAndDriverInfoByPage: config.api_url + 'platformModule-antiepidemicManageBwty@queryCarAndDriverInfoByPage',
    delCarAndDriverInfo: config.api_url + 'platformModule-antiepidemicManageBwty@delCarAndDriverInfo',

    // 分页查询洗车记录
    findAllCarWashChecksPlatform: config.api_url + 'platformModule-carSecurityCheckActionFactory@findAllCarWashChecksPlatform',
    findAllCarWashChecksForApp: config.api_url + 'platformModule-carSecurityCheckActionFactory@findAllCarWashChecksForApp',
  },

  // 车辆安全检查管理
  carSecurityCheckManage: {
    queryAll: config.api_url + 'platformModule-carSecurityCheckActionFactory@findAllCarSecurityChecksPlatform',
    export: config.api_url_load + 'carSecurityCheckExport/exportSecurityChecks',
    exportByIds: config.api_url_load + 'carSecurityCheckExport/exportSecurityChecksByIds',
    deleteCheckInfo: config.api_url + 'platformModule-carSecurityCheckActionFactory@deleteCheckInfo',
  },
  // App管理
  AppManage: {
    queryAll: config.api_url + 'platformModule-appManageActionFactory@selectAppManeges',
    AppDelete: config.api_url + 'platformModule-appManageActionFactory@deleteAppManege',
    AppDeleteSelected: config.api_url + 'platformModule-appManageActionFactory@deleteAppManeges',
    AppAdd: config.api_url + 'platformModule-appManageActionFactory@createAppManage',
    getAppById: config.api_url + 'platformModule-appManageActionFactory@getAppManage',
    AppModify: config.api_url + 'platformModule-appManageActionFactory@updateAppManege',
    getVersionByAppId: config.api_url + 'platformModule-appManageActionFactory@getVersionByAppManegeType',
    versionDelete: config.api_url + 'platformModule-versionActionFactory@deleteVersion',
    versionDeleteSelected: config.api_url + 'platformModule-versionActionFactory@deleteVersions',
    versionAdd: config.api_url + 'platformModule-versionActionFactory@createVersion',
    getVersionByversionId: config.api_url + 'platformModule-versionActionFactory@getVersion',
    versionModify: config.api_url + 'platformModule-versionActionFactory@updateVersion',
    findOneVersionByAppId: config.api_url + 'platformModule-versionActionFactory@findOneVersionByAppId',
    versionUsing: config.api_url + 'platformModule-versionActionFactory@updateVersionToUsing',
    versionStop: config.api_url + 'platformModule-versionActionFactory@updateVersionToStop',
    versionAddWithUsing: config.api_url + 'platformModule-versionActionFactory@updateVersionToStop'
  },
// 电子运单缴费管理
  waybillPay: {
    queryAll: config.api_url + 'platformappModule-appElectronicWaybillPayRecordFactory@getPageElectronicWaybillPayRecord',
    refund:config.api_url + 'platformappModule-taskPayAppActionFactory@refund'
  },
  // 提货协同
  entrust: {
    queryEntrust: config.api_url + 'platformModule-entrustCoordinationActionFactory@queryEntrust',
    queryEntrustById: config.api_url + 'platformModule-entrustCoordinationActionFactory@getById',
    getPlanByEntrust: config.api_url + 'logisticsModule-entrustCoor@getDeliveryPlanByEntrustSn',
    queryPlan: config.api_url + 'platformModule-entrustCoordinationActionFactory@queryDeliveryPlan',
    queryPlanById: config.api_url + 'platformModule-entrustCoordinationActionFactory@getDeliveryPlanById',
    queryTaskById: config.api_url + 'platformModule-entrustCoordinationActionFactory@getTransportTaskById',
    uploadPound: config.api_url + 'logisticsModule-entrustCoor@uploadPoundList',
    queryTaskAll: config.api_url + 'platformModule-entrustCoordinationActionFactory@queryTransportTask',
    exportTaskData: config.api_url_load + 'nonstandardTaskExport/exportTaskData',
  },

  // 协议管理
  agreementManage: {
    queryAll: config.api_url + 'platformModule-protocolActionFactory@getProtocols',
    agreementDelete: config.api_url + 'platformModule-protocolActionFactory@deleteProtocol',
    agreementDeleteSelected: config.api_url + 'platformModule-protocolActionFactory@deleteProtocols',
    agreementAdd: config.api_url + 'platformModule-protocolActionFactory@createProtocol',
    queryById: config.api_url + 'platformModule-protocolActionFactory@getProtocol',
    agreementModify: config.api_url + 'platformModule-protocolActionFactory@updateProcotol'
  },

  // 报价列表
  reportList: {
    queryAllCarrierOrOwner: config.api_url + 'platformModule-corporate@getAllOwnerOrCarrier',
    merchantRegistrationInfo: {
      queryAll: config.api_url + 'platformModule-reportform@corporateRegistered'
    },
    // 客商月度统计信息
    merchantsMonthlyStatistics: {
      queryAll: config.api_url + 'platformModule-reportform@corporateRegisteredByMonth'
    },
    sourceRelease: {
      queryAll: config.api_url + 'platformModule-reportform@goodsPublish'
    },
    sourceTransaction: {
      queryAll: config.api_url + 'platformModule-reportform@goodsTransaction'
    },
    carrierOrderQuantity: {
      queryCarrier: config.api_url + 'platformModule-corporate@findAllCorporateByPage',
      queryAll: config.api_url + 'platformModule-reportform@carrierOrders'
    },
    // 货主发布量月度排名
    shipperMonthlyRanking: {
      queryAll: config.api_url + 'platformModule-reportform@ownerGoodsSequence'
    },
    // 承运商接单量月度排名
    carrierMonthlyranking: {
      queryAll: config.api_url + 'platformModule-reportform@carrierOrderSequenceByMonth'
    },
    // 货主发布量月度统计
    shippersMonthlyStatistics: {
      queryAll: config.api_url + 'platformModule-reportform@ownerGoodsByMonth'
    },
    // 承运商接单量月度统计
    carrierMonthlyOrderStatistics: {
      queryAll: config.api_url + 'platformModule-reportform@carrierOrderByMonth'
    },
    // 货主发布量成交量统计明细
    shipperStatisticsDetails: {
      queryAll: config.api_url + 'platformModule-reportform@ownerGoodsOrder',
      queryDetails: config.api_url + 'platformModule-reportform@ownerGoodsOrderDetail'
    },
    // 承运商接单量统计明细
    carrierStatisticsDetails: {
      queryAll: config.api_url + 'platformModule-reportform@carrierOrdersInfo',
      queryDetails: config.api_url + 'platformModule-reportform@carrierOrdersInfoDetail'
    }
  },

  // 设备绑定
  bindInfo: {
    queryDevices: config.api_url + 'platformModule-deviceActionFactory@queryDevices',
    unBindDevice: config.api_url + 'platformModule-deviceActionFactory@unBindDevice',
    bindDevice: config.api_url + 'platformModule-deviceActionFactory@bindDevice',
    queryBindInfo: config.api_url + 'platformModule-deviceActionFactory@queryBindInfo',
    createDevice: config.api_url + 'platformModule-deviceActionFactory@createDevice',
    // 导出
    export: config.api_url_load + 'export/exportDevice'
  },

  // 接口调用记录
  interfaceLog: {
    queryAll: config.api_url + 'platformModule-vehloctReqHistory@pageVehloctReqHistory',
    queryById: config.api_url + 'platformModule-vehloctReqHistory@findById',
    extsysQueryAll: config.api_url + 'platformModule-vehloctExtsysReqHistory@pageVehloctExtsysReqHistory',
    extsysQueryById: config.api_url + 'platformModule-vehloctExtsysReqHistory@findById',

    // 承运商接单量统计明细
    carMonitorLog: {
      zhList: config.api_url + 'platformModule-vehloctMonitor@queryZhMonitorVehloctsCache',
      zjList: config.api_url + 'platformModule-vehloctMonitor@queryZjMonitorVehloctsCache',
      deleteZhMonitorVehloctsCache: config.api_url + 'platformModule-vehloctMonitor@deleteZhMonitorVehloctsCache',
      deleteZjMonitorVehloctsCache: config.api_url + 'platformModule-vehloctMonitor@deleteZjMonitorVehloctsCache'
    }
  },
  // 公共基础数据
  sysBaseData: {
    queryGoodsType: config.api_url + 'platformModule-goodsTypeInfoActionFactory@queryGoodsType'
  },
  // 测算
  costEstimation: {
    save: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@createModelInformation',
    search: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@getAllLogisticsFreightEstimationModel',
    edit: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@updateModelInformation',
    delete: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@deleteModelInformation',
    queryResultList: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@getAllLogisticsFreightEstimationResult',
    deleteResult: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@deleteResultInformation',
    modelCalculate: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@dataCalculate',
    getDetail: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@getModelDetailById',
    doCompute: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@dataCalculate',
    saveCompute: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@createEstimationInformation',
    resultDetail: config.api_url + 'platformModule-logisticsFreightEstimationActionFactory@getResultDetailById',
  }
}



// WEBPACK FOOTER //
// ./src/common/api.js